/*
 * Blank Apparel Wholesale product page (sections/main-product-wholesale.liquid).
 *
 * - Color grid + size matrix per warehouse with per-size order quantities.
 * - Transit days / estimated delivery estimated from the ship-to ZIP.
 * - Quantities are kept per variant + warehouse across color changes and
 *   added in one /cart/add.js call; warehouse and ETA are line item properties.
 */
(function () {
  'use strict';

  var WAREHOUSES = [
    { code: 'TX', name: 'Fort Worth, TX', lat: 32.75, lng: -97.33, cutoff: 15, tz: 'America/Chicago', tzLabel: 'CT' },
    { code: 'GA', name: 'McDonough, GA', lat: 33.45, lng: -84.15, cutoff: 16, tz: 'America/New_York', tzLabel: 'ET' },
    { code: 'IL', name: 'Lockport, IL', lat: 41.59, lng: -88.06, cutoff: 16, tz: 'America/Chicago', tzLabel: 'CT' },
    { code: 'KS', name: 'Olathe, KS', lat: 38.88, lng: -94.82, cutoff: 17, tz: 'America/Chicago', tzLabel: 'CT' },
    { code: 'OH', name: 'West Chester, OH', lat: 39.33, lng: -84.41, cutoff: 18, tz: 'America/New_York', tzLabel: 'ET' },
    { code: 'FO', name: 'Orlando, FL', lat: 28.54, lng: -81.38, cutoff: 17, tz: 'America/New_York', tzLabel: 'ET' },
    { code: 'PA', name: 'Reading, PA', lat: 40.34, lng: -75.93, cutoff: 16, tz: 'America/New_York', tzLabel: 'ET' },
    { code: 'MA', name: 'Middleboro, MA', lat: 41.89, lng: -70.91, cutoff: 17, tz: 'America/New_York', tzLabel: 'ET' },
    { code: 'CN', name: 'Fresno, CA', lat: 36.74, lng: -119.79, cutoff: 16, tz: 'America/Los_Angeles', tzLabel: 'PT' },
    { code: 'NV', name: 'Reno, NV', lat: 39.53, lng: -119.81, cutoff: 16, tz: 'America/Los_Angeles', tzLabel: 'PT' }
  ];

  // Relative stock weight per warehouse, used only when splitting Shopify inventory.
  var WAREHOUSE_WEIGHT = { TX: 1.1, GA: 1.2, IL: 1.2, KS: 0.8, OH: 0.9, FO: 0.9, PA: 1, MA: 0.9, CN: 1.1, NV: 0.9 };

  // ZIP3 prefix ranges -> approximate state centroid [lat, lng].
  var ZIP3_REGIONS = [
    [5, 5, 40.8, -73.1], [10, 27, 42.3, -71.8], [28, 29, 41.7, -71.5], [30, 38, 43.7, -71.6],
    [39, 49, 45.4, -69.2], [50, 59, 44.1, -72.7], [60, 69, 41.6, -72.7], [70, 89, 40.2, -74.6],
    [100, 149, 42.2, -74.9], [150, 196, 40.9, -77.8], [197, 199, 39, -75.5], [200, 205, 38.9, -77],
    [206, 219, 39.1, -76.8], [220, 246, 37.5, -78.9], [247, 268, 38.6, -80.6], [270, 289, 35.6, -79.4],
    [290, 299, 33.9, -80.9], [300, 319, 32.7, -83.4], [320, 349, 28.6, -82.4], [350, 369, 32.8, -86.8],
    [370, 385, 35.9, -86.4], [386, 397, 32.7, -89.7], [398, 399, 31.6, -84.2], [400, 427, 37.5, -85.3],
    [430, 458, 40.3, -82.8], [460, 479, 39.9, -86.3], [480, 499, 43.3, -84.5], [500, 528, 42.1, -93.5],
    [530, 549, 44.6, -89.8], [550, 567, 45.7, -93.9], [570, 577, 44.4, -100.2], [580, 588, 47.5, -100.5],
    [590, 599, 46.9, -110.4], [600, 629, 40, -89.2], [630, 658, 38.5, -92.5], [660, 679, 38.5, -98.4],
    [680, 693, 41.5, -99.8], [700, 714, 31.1, -92], [716, 729, 34.9, -92.4], [730, 749, 35.6, -97.5],
    [750, 799, 31.1, -97.6], [800, 816, 39, -105.5], [820, 831, 43, -107.5], [832, 838, 44.2, -114.6],
    [840, 847, 40.1, -111.9], [850, 865, 34.2, -111.7], [870, 884, 34.4, -106.1], [885, 885, 31.8, -106.4],
    [889, 898, 38.5, -117], [900, 961, 36.8, -119.4], [967, 968, 21.1, -157.5], [970, 979, 44, -120.5],
    [980, 994, 47.4, -120.5], [995, 999, 61.4, -152.3]
  ];

  // S&S color names -> hex, used when Shopify has no swatch color for a value.
  var COLOR_HEX = {
    'Berry': '#7E4966', 'Black': '#25282A', 'Blossom': '#F8BED6', 'Blue Jean': '#647692', 'Blue Spruce': '#004C45',
    'Brick': '#8A1538', 'Bright Salmon': '#FF6D6A', 'Burnt Orange': '#FF6900', 'Butter': '#F5E1A4', 'Chalky Mint': '#5CB8B2',
    'Chambray': '#BDD6E6', 'China Blue': '#002855', 'Crimson': '#A4123F', 'Crunchberry': '#EF4A81', 'Denim': '#425563',
    'Espresso': '#533625', 'Flo Blue': '#5576D1', 'Granite': '#7C878E', 'Grape': '#211551', 'Graphite': '#1D252D',
    'Grey': '#716E6A', 'Hemp': '#1C4220', 'Hydrangea': '#A7BCD6', 'Ice Blue': '#5B7F95', 'Island Green': '#00957A',
    'Island Reef': '#8FE2B0', 'Ivory': '#E7CEB5', 'Khaki': '#A09074', 'Lagoon': '#05C3DE', 'Light Green': '#5C7F71',
    'Melon': '#FA9370', 'Midnight': '#1B365D', 'Mustard': '#F2CD00', 'Navy': '#0C2340', 'Neon Red Orange': '#FF585D',
    'Orchid': '#C7B2DE', 'Paprika': '#CE0037', 'Peachy': '#D46C36', 'Pepper': '#4E4B48', 'Red': '#C8102E',
    'Royal Caribe': '#0082BA', 'Sandstone': '#A69F88', 'Seafoam': '#487A7B', 'Terracotta': '#E3775E', 'True Navy': '#041E42',
    'Violet': '#7474C1', 'Washed Denim': '#6787B7', 'Watermelon': '#F4364C', 'White': '#FFFFFF', 'Yam': '#BE531C',
    'Banana': '#F4E3A1', 'Bay': '#B8C3AE', 'Bright Orange': '#F26B21', 'Chili': '#8E2A22', 'Citrus': '#E2E26A',
    'Dusk': '#8C93A8', 'Emerald': '#0F7A56', 'Moss': '#6D7250', 'Mystic Blue': '#7B98B5', 'Neon Cantaloupe': '#FF9F6E',
    'Neon Lemon': '#EEF36B', 'Neon Pink': '#FF4FA1', 'Neon Violet': '#A46BDF', 'Periwinkle': '#8E9FD6', 'Rose Quartz': '#E6B3B7',
    'Sage': '#8B9A7D', 'Sapphire': '#0073B5', 'Wine': '#5B1F2E', 'Yankey Blue': '#1F2A44', 'Yankee Blue': '#1F2A44'
  };

  var ALL = 'ALL';
  var SIZE_ORDER = ['NB', '3M', '6M', '12M', '18M', '24M', '2T', '3T', '4T', '5T', '6T', 'XXS', '2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', 'XXXL', '4XL', '5XL', '6XL', 'OSFA', 'ONE SIZE'];

  function $(root, selector) { return root.querySelector(selector); }
  function $$(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function parseJson(node, fallback) {
    if (!node) return fallback;
    try { return JSON.parse(node.textContent); } catch (error) { return fallback; }
  }

  function hashString(value) {
    var hash = 2166136261;
    var text = String(value);
    for (var i = 0; i < text.length; i++) {
      hash ^= text.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var noDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var template = format || '${{amount}}';
    return template.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      if (key === 'amount_no_decimals') return noDecimals;
      if (key === 'amount_with_comma_separator') return parts[0] + ',' + parts[1];
      return withCommas;
    });
  }

  function formatNumber(value) {
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function textColorFor(hex) {
    var clean = String(hex || '').replace('#', '');
    if (clean.length === 3) clean = clean.split('').map(function (c) { return c + c; }).join('');
    if (clean.length !== 6) return '#0f172a';
    var r = parseInt(clean.substr(0, 2), 16);
    var g = parseInt(clean.substr(2, 2), 16);
    var b = parseInt(clean.substr(4, 2), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6 ? '#0f172a' : '#ffffff';
  }

  function sizeRank(size) {
    var index = SIZE_ORDER.indexOf(String(size).toUpperCase());
    return index === -1 ? 999 : index;
  }

  function isPlusSize(size) {
    return sizeRank(size) >= SIZE_ORDER.indexOf('3XL') && sizeRank(size) !== 999;
  }

  /* ---------------- Transit estimate ---------------- */

  function zipToPoint(zip) {
    var prefix = parseInt(String(zip).slice(0, 3), 10);
    if (!/^\d{5}$/.test(String(zip)) || isNaN(prefix)) return null;
    for (var i = 0; i < ZIP3_REGIONS.length; i++) {
      var region = ZIP3_REGIONS[i];
      if (prefix >= region[0] && prefix <= region[1]) return { lat: region[2], lng: region[3] };
    }
    return null;
  }

  function distanceMiles(a, b) {
    var toRad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * toRad;
    var dLng = (b.lng - a.lng) * toRad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a.lat * toRad) * Math.cos(b.lat * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 3959 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  }

  function transitDays(warehouse, point) {
    if (!point) return null;
    var miles = distanceMiles(warehouse, point);
    if (miles < 300) return 1;
    if (miles < 700) return 2;
    if (miles < 1300) return 3;
    if (miles < 2000) return 4;
    return 5;
  }

  function zonedNow(timeZone) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone, year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', hourCycle: 'h23', weekday: 'short'
      }).formatToParts(new Date());
      var map = {};
      parts.forEach(function (part) { map[part.type] = part.value; });
      return {
        date: new Date(Number(map.year), Number(map.month) - 1, Number(map.day)),
        hour: Number(map.hour)
      };
    } catch (error) {
      var now = new Date();
      return { date: new Date(now.getFullYear(), now.getMonth(), now.getDate()), hour: now.getHours() };
    }
  }

  function addBusinessDays(date, days) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) added++;
    }
    return result;
  }

  function estimateDelivery(warehouse, days, processingDays) {
    if (days == null) return null;
    var now = zonedNow(warehouse.tz);
    var ship = new Date(now.date.getTime());
    var weekend = ship.getDay() === 0 || ship.getDay() === 6;
    if (weekend || now.hour >= warehouse.cutoff) ship = addBusinessDays(ship, 1);
    if (processingDays > 0) ship = addBusinessDays(ship, processingDays);
    var arrival = addBusinessDays(ship, days);
    var weekday = arrival.toLocaleDateString('en-US', { weekday: 'short' });
    return weekday + ' ' + (arrival.getMonth() + 1) + '/' + arrival.getDate();
  }

  function cutoffLabel(warehouse) {
    var hour = warehouse.cutoff > 12 ? warehouse.cutoff - 12 : warehouse.cutoff;
    return hour + ':00 ' + warehouse.tzLabel;
  }

  /* ---------------- Page controller ---------------- */

  function WholesaleProduct(root) {
    this.root = root;
    this.moneyFormat = root.dataset.moneyFormat;
    this.stockSource = root.dataset.stockSource || 'auto';
    this.caseQty = parseInt(root.dataset.caseQty, 10) || 48;
    this.caseQtyPlus = parseInt(root.dataset.caseQtyPlus, 10) || 36;
    this.processingDays = parseInt(root.dataset.processingDays, 10) || 0;

    var hidden = (root.dataset.hiddenWarehouses || '').split(',').map(function (code) { return code.trim(); });
    this.warehouses = WAREHOUSES.filter(function (warehouse) { return hidden.indexOf(warehouse.code) === -1; });

    this.options = parseJson($(root, '[data-bapw-options]'), { colors: [], sizes: [], images: [] });
    this.variants = [];
    this.byColor = {};
    this.quantities = {}; // "variantId|warehouseCode" -> qty
    this.selectedWarehouse = null;
    this.zip = this.loadZip() || root.dataset.defaultZip || '';

    this.bindStatic();
    this.loadVariants();
  }

  WholesaleProduct.prototype.loadZip = function () {
    try { return window.localStorage.getItem('bapw_zip'); } catch (error) { return null; }
  };

  WholesaleProduct.prototype.saveZip = function (zip) {
    try { window.localStorage.setItem('bapw_zip', zip); } catch (error) { /* storage unavailable */ }
  };

  WholesaleProduct.prototype.loadVariants = function () {
    var self = this;
    var firstNode = $(self.root, '[data-bapw-variants]');
    var pages = firstNode ? parseInt(firstNode.dataset.pages, 10) || 1 : 1;
    var variants = parseJson(firstNode, []);
    var requests = [];

    for (var page = 2; page <= pages; page++) {
      requests.push(self.fetchVariantPage(page));
    }

    Promise.all(requests).then(function (extraPages) {
      extraPages.forEach(function (list) { variants = variants.concat(list); });
      self.setVariants(variants);
    }).catch(function () {
      self.setVariants(variants);
    });
  };

  WholesaleProduct.prototype.fetchVariantPage = function (page) {
    var root = this.root;
    var params = new URLSearchParams({ section_id: root.dataset.sectionId, page: String(page) });
    if (root.dataset.view) params.set('view', root.dataset.view);
    return fetch(root.dataset.productUrl + '?' + params.toString())
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return parseJson(doc.querySelector('[data-bapw-variants]'), []);
      });
  };

  WholesaleProduct.prototype.setVariants = function (variants) {
    var self = this;
    var seen = {};
    self.variants = variants.filter(function (variant) {
      if (seen[variant.id]) return false;
      seen[variant.id] = true;
      return true;
    });

    self.byColor = {};
    self.variants.forEach(function (variant) {
      variant.stock = self.warehouseStock(variant);
      (self.byColor[variant.c] = self.byColor[variant.c] || []).push(variant);
    });

    var optionColors = self.options.colors.map(function (color) { return color.name; });
    self.colors = optionColors.filter(function (name) { return self.byColor[name]; });
    Object.keys(self.byColor).forEach(function (name) {
      if (self.colors.indexOf(name) === -1) self.colors.push(name);
    });

    var initial = null;
    var params = new URLSearchParams(window.location.search);
    var variantParam = params.get('variant');
    if (variantParam) {
      self.variants.some(function (variant) {
        if (String(variant.id) === variantParam) { initial = variant.c; return true; }
        return false;
      });
    }
    if (!initial) {
      initial = self.colors.filter(function (name) {
        return self.byColor[name].some(function (variant) { return variant.a; });
      })[0] || self.colors[0];
    }

    var count = $(self.root, '[data-bapw-color-count]');
    if (count) count.textContent = self.colors.length;

    self.renderSwatches();
    self.selectColor(initial);
  };

  /* Warehouse stock for a variant: metafield JSON or a stable split of Shopify inventory. */
  WholesaleProduct.prototype.warehouseStock = function (variant) {
    var stock = {};
    var useMetafield = variant.wh && typeof variant.wh === 'object' && this.stockSource !== 'split';

    if (useMetafield) {
      this.warehouses.forEach(function (warehouse) {
        stock[warehouse.code] = Math.max(0, parseInt(variant.wh[warehouse.code], 10) || 0);
      });
      return stock;
    }

    if (this.stockSource === 'metafield') {
      this.warehouses.forEach(function (warehouse) { stock[warehouse.code] = 0; });
      return stock;
    }

    // Untracked-and-available variants have no real count, so show a nominal 500 per warehouse.
    var untracked = variant.a && variant.q <= 0;
    var total = untracked ? 500 * this.warehouses.length : Math.max(0, variant.q);
    var weights = this.warehouses.map(function (warehouse) {
      var jitter = (hashString(variant.id + warehouse.code) % 1000) / 1000; // 0..1
      return (WAREHOUSE_WEIGHT[warehouse.code] || 1) * (0.35 + jitter);
    });
    var weightSum = weights.reduce(function (sum, weight) { return sum + weight; }, 0);
    var assigned = 0;

    this.warehouses.forEach(function (warehouse, index) {
      var qty = Math.floor(total * weights[index] / weightSum);
      stock[warehouse.code] = qty;
      assigned += qty;
    });

    // Hand out the rounding remainder so warehouses always add up to the Shopify total.
    var cursor = hashString(variant.id) % this.warehouses.length;
    while (assigned < total && this.warehouses.length) {
      stock[this.warehouses[cursor % this.warehouses.length].code] += 1;
      assigned += 1;
      cursor += 1;
    }
    return stock;
  };

  WholesaleProduct.prototype.globalStock = function (variant) {
    var total = 0;
    for (var code in variant.stock) total += variant.stock[code];
    return total;
  };

  WholesaleProduct.prototype.caseFor = function (variant) {
    if (variant.case) return variant.case;
    return isPlusSize(variant.s) ? this.caseQtyPlus : this.caseQty;
  };

  WholesaleProduct.prototype.hexFor = function (name) {
    var fromShopify = null;
    this.options.colors.some(function (color) {
      if (color.name === name && color.hex) { fromShopify = color.hex; return true; }
      return false;
    });
    if (fromShopify) return fromShopify;
    if (COLOR_HEX[name]) return COLOR_HEX[name];
    var simplified = String(name).replace(/^(heather|antique|safety|vintage|solid|pigment|garment dyed)\s+/i, '');
    return COLOR_HEX[simplified] || null;
  };

  WholesaleProduct.prototype.colorImage = function (name) {
    var list = this.byColor[name] || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].img) return { src: list[i].img, thumb: list[i].thumb };
    }
    return null;
  };

  /* ---------------- Rendering ---------------- */

  WholesaleProduct.prototype.renderSwatches = function () {
    var self = this;
    var container = $(self.root, '[data-bapw-swatches]');
    if (!container) return;

    container.innerHTML = self.colors.map(function (name) {
      var hex = self.hexFor(name);
      var available = self.byColor[name].some(function (variant) { return variant.a; });
      var style = '';
      var classes = 'bapw__swatch';

      if (hex) {
        style = 'background-color:' + hex + ';color:' + textColorFor(hex) + ';';
      } else {
        var image = self.colorImage(name);
        if (image) {
          style = 'background-image:url(' + JSON.stringify(image.thumb || image.src) + ');background-color:#94a3b8;';
          classes += ' is-image';
        } else {
          style = 'background-color:#e2e8f0;color:#0f172a;';
        }
      }
      if (!available) classes += ' is-soldout';

      return '<button type="button" class="' + classes + '" style="' + escapeHtml(style) + '" data-color="' +
        escapeHtml(name) + '" aria-pressed="false" title="' + escapeHtml(name + (available ? '' : ' (sold out)')) + '">' +
        escapeHtml(name) + '</button>';
    }).join('');
  };

  WholesaleProduct.prototype.updateSwatchCounts = function () {
    var self = this;
    $$(self.root, '[data-bapw-swatches] [data-color]').forEach(function (button) {
      var pieces = 0;
      (self.byColor[button.dataset.color] || []).forEach(function (variant) {
        self.warehouses.forEach(function (warehouse) {
          pieces += self.quantities[variant.id + '|' + warehouse.code] || 0;
        });
      });
      var badge = button.querySelector('.bapw__swatch-count');
      if (pieces > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'bapw__swatch-count';
          button.appendChild(badge);
        }
        badge.textContent = pieces;
      } else if (badge) {
        badge.remove();
      }
    });
  };

  WholesaleProduct.prototype.selectColor = function (name) {
    var self = this;
    self.selectedColor = name;

    $$(self.root, '[data-bapw-swatches] [data-color]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.color === name ? 'true' : 'false');
    });
    $$(self.root, '[data-bapw-selected-color]').forEach(function (node) { node.textContent = name; });

    self.renderGallery();
    if (!self.selectedWarehouse) self.selectedWarehouse = self.nearestWarehouseCode();
    self.renderWarehouses();
    self.renderTable();
    self.updateSwatchCounts();

    var first = (self.byColor[name] || [])[0];
    if (first && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', first.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  WholesaleProduct.prototype.renderGallery = function () {
    var self = this;
    var mainImage = $(self.root, '[data-bapw-main-image]');
    var thumbs = $(self.root, '[data-bapw-thumbs]');
    var name = String(self.selectedColor || '').toLowerCase();

    var images = (self.options.images || []).filter(function (image) {
      return image.alt && String(image.alt).toLowerCase().indexOf(name) !== -1;
    });
    var colorImage = self.colorImage(self.selectedColor);
    if (colorImage && !images.some(function (image) { return image.src === colorImage.src; })) {
      images.unshift({ src: colorImage.src, thumb: colorImage.thumb, alt: self.selectedColor });
    }

    if (mainImage && images[0]) {
      mainImage.src = images[0].src;
      mainImage.alt = images[0].alt || self.selectedColor;
    }

    if (!thumbs) return;
    if (images.length < 2) {
      thumbs.innerHTML = '';
      return;
    }
    thumbs.innerHTML = images.slice(0, 8).map(function (image, index) {
      return '<button type="button" class="bapw__thumb" data-src="' + escapeHtml(image.src) + '" aria-current="' +
        (index === 0 ? 'true' : 'false') + '"><img src="' + escapeHtml(image.thumb || image.src) + '" alt="' +
        escapeHtml(image.alt || '') + '" loading="lazy" width="56" height="56"></button>';
    }).join('');
  };

  WholesaleProduct.prototype.nearestWarehouseCode = function () {
    var point = zipToPoint(this.zip);
    if (!point || !this.warehouses.length) return this.warehouses.length ? this.warehouses[0].code : ALL;
    var best = null;
    this.warehouses.forEach(function (warehouse) {
      var miles = distanceMiles(warehouse, point);
      if (!best || miles < best.miles) best = { code: warehouse.code, miles: miles };
    });
    return best.code;
  };

  WholesaleProduct.prototype.renderWarehouses = function () {
    var self = this;
    var container = $(self.root, '[data-bapw-warehouses]');
    if (!container) return;

    var chips = [{ code: ALL, name: 'All Warehouses' }].concat(self.warehouses);
    container.innerHTML = chips.map(function (warehouse) {
      return '<button type="button" class="bapw__chip" data-warehouse="' + warehouse.code + '" aria-pressed="' +
        (warehouse.code === self.selectedWarehouse ? 'true' : 'false') + '">' + escapeHtml(warehouse.name) + '</button>';
    }).join('');

    var zipInput = $(self.root, '[data-bapw-zip]');
    if (zipInput && document.activeElement !== zipInput) zipInput.value = self.zip;
  };

  WholesaleProduct.prototype.sortedWarehouses = function () {
    var point = zipToPoint(this.zip);
    var list = this.warehouses.slice();
    if (!point) return list;
    return list.sort(function (a, b) { return distanceMiles(a, point) - distanceMiles(b, point); });
  };

  WholesaleProduct.prototype.renderTable = function () {
    var self = this;
    var container = $(self.root, '[data-bapw-table]');
    var variants = (self.byColor[self.selectedColor] || []).slice().sort(function (a, b) {
      var order = self.options.sizes || [];
      var ia = order.indexOf(a.s);
      var ib = order.indexOf(b.s);
      if (ia !== -1 && ib !== -1) return ia - ib;
      return sizeRank(a.s) - sizeRank(b.s);
    });

    if (!variants.length) {
      container.innerHTML = '<div class="bapw__loading">No sizes available for this color.</div>';
      return;
    }

    var point = zipToPoint(self.zip);
    var rows = self.selectedWarehouse === ALL
      ? self.sortedWarehouses()
      : self.warehouses.filter(function (warehouse) { return warehouse.code === self.selectedWarehouse; });

    var head = '<thead><tr><th class="bapw__cell-left" scope="col">Color</th><th class="bapw__cell-rowlabel" scope="col"></th>' +
      variants.map(function (variant) { return '<th scope="col">' + escapeHtml(variant.s) + '</th>'; }).join('') +
      '</tr></thead>';

    var info = '<tbody class="bapw__group">' +
      '<tr class="bapw__row bapw__row-case"><td class="bapw__cell-left" rowspan="3"><div class="bapw__color-name">' + escapeHtml(self.selectedColor) + '</div></td>' +
      '<td class="bapw__cell-rowlabel">Case Qty</td>' +
      variants.map(function (variant) { return '<td data-size="' + escapeHtml(variant.s) + '">' + self.caseFor(variant) + '</td>'; }).join('') + '</tr>' +
      '<tr class="bapw__row bapw__row-price"><td class="bapw__cell-rowlabel">Price</td>' +
      variants.map(function (variant) {
        var compare = variant.cp > variant.p ? '<s>' + formatMoney(variant.cp, self.moneyFormat) + '</s>' : '';
        return '<td class="bapw__price" data-size="' + escapeHtml(variant.s) + '">' + compare + formatMoney(variant.p, self.moneyFormat) + '</td>';
      }).join('') + '</tr>' +
      '<tr class="bapw__row bapw__row-global"><td class="bapw__cell-rowlabel">Global Inv.</td>' +
      variants.map(function (variant) {
        return '<td class="bapw__global" data-size="' + escapeHtml(variant.s) + '">' + formatNumber(self.globalStock(variant)) + '</td>';
      }).join('') + '</tr></tbody>';

    var warehouseRows = rows.map(function (warehouse) {
      var days = transitDays(warehouse, point);
      var eta = estimateDelivery(warehouse, days, self.processingDays);
      var transit = days != null
        ? '<div class="bapw__wh-transit"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 5h11v9h1.5l2-3.5H21V17h-1.6a2.4 2.4 0 0 1-4.8 0H9.4a2.4 2.4 0 0 1-4.8 0H3V5Zm14.3 7-1.1 2H19v-2h-1.7ZM7 18.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm10 0a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z"/></svg>' +
          days + ' day' + (days === 1 ? '' : 's') + ' transit · Cut-off ' + cutoffLabel(warehouse) + '</div>' +
          '<div class="bapw__wh-eta">Est. Delivery: ' + eta + '</div>'
        : '<div class="bapw__wh-eta">Cut-off ' + cutoffLabel(warehouse) + ' · enter ZIP for ETA</div>';

      return '<tbody class="bapw__group">' +
        '<tr class="bapw__row bapw__row-inventory"><td class="bapw__cell-left" rowspan="2"><div class="bapw__wh-name">' + escapeHtml(warehouse.name) + '</div>' + transit + '</td>' +
        '<td class="bapw__cell-rowlabel">Inventory</td>' +
        variants.map(function (variant) {
          var qty = variant.stock[warehouse.code] || 0;
          return '<td class="bapw__inv' + (qty ? '' : ' is-zero') + '" data-size="' + escapeHtml(variant.s) + '">' + formatNumber(qty) + '</td>';
        }).join('') + '</tr>' +
        '<tr class="bapw__row bapw__row-qty"><td class="bapw__cell-rowlabel">Order Qty</td>' +
        variants.map(function (variant) {
          var key = variant.id + '|' + warehouse.code;
          var value = self.quantities[key] || '';
          var max = variant.oversell ? '' : (variant.stock[warehouse.code] || 0);
          var disabled = !variant.oversell && !max;
          var stockLabel = max === '' ? '' : formatNumber(variant.stock[warehouse.code] || 0) + ' in stock';
          // data-* values drive the stacked card layout used on small screens.
          return '<td class="bapw__qty-cell" data-size="' + escapeHtml(variant.s) +
            '" data-price="' + escapeHtml(formatMoney(variant.p, self.moneyFormat)) +
            '" data-stock="' + escapeHtml(stockLabel) +
            '" data-case="' + escapeHtml('case ' + self.caseFor(variant)) + '"><input type="number" class="bapw__qty' + (value ? ' has-value' : '') + '" min="0" step="1" inputmode="numeric"' +
            (max !== '' ? ' max="' + max + '"' : '') + ' value="' + value + '" data-key="' + key + '"' +
            (disabled ? ' disabled' : '') + ' aria-label="' + escapeHtml(self.selectedColor + ' ' + variant.s + ' from ' + warehouse.name) + '"></td>';
        }).join('') + '</tr></tbody>';
    }).join('');

    container.innerHTML = '<table class="bapw__table">' + head + info + warehouseRows + '</table>';

    var note = $(self.root, '[data-bapw-note]');
    if (note) {
      note.textContent = point
        ? 'Transit estimates to ZIP ' + self.zip + '. Business days; orders placed after cut-off ship the next business day.'
        : 'Enter a 5-digit ZIP to see transit time and estimated delivery.';
    }
    self.updateSummary();
  };

  /* ---------------- Order state ---------------- */

  WholesaleProduct.prototype.findVariant = function (id) {
    for (var i = 0; i < this.variants.length; i++) {
      if (String(this.variants[i].id) === String(id)) return this.variants[i];
    }
    return null;
  };

  WholesaleProduct.prototype.warehouseByCode = function (code) {
    for (var i = 0; i < WAREHOUSES.length; i++) {
      if (WAREHOUSES[i].code === code) return WAREHOUSES[i];
    }
    return null;
  };

  WholesaleProduct.prototype.setQuantity = function (input) {
    var key = input.dataset.key;
    var parts = key.split('|');
    var variant = this.findVariant(parts[0]);
    var value = Math.max(0, parseInt(input.value, 10) || 0);
    var max = variant && !variant.oversell ? (variant.stock[parts[1]] || 0) : Infinity;

    input.classList.toggle('is-over', value > max);
    if (value > max) value = max;

    if (value > 0) this.quantities[key] = value;
    else delete this.quantities[key];

    input.classList.toggle('has-value', value > 0);
    this.updateSummary();
    this.updateSwatchCounts();
  };

  WholesaleProduct.prototype.orderLines = function () {
    var self = this;
    return Object.keys(self.quantities).map(function (key) {
      var parts = key.split('|');
      var variant = self.findVariant(parts[0]);
      var warehouse = self.warehouseByCode(parts[1]);
      if (!variant || !warehouse) return null;
      return { key: key, variant: variant, warehouse: warehouse, qty: self.quantities[key] };
    }).filter(Boolean);
  };

  WholesaleProduct.prototype.updateSummary = function () {
    var self = this;
    var lines = self.orderLines();
    var pieces = 0;
    var subtotal = 0;

    lines.forEach(function (line) {
      pieces += line.qty;
      subtotal += line.qty * line.variant.p;
    });

    var container = $(self.root, '[data-bapw-summary-lines]');
    if (container) {
      container.innerHTML = lines.length
        ? lines.map(function (line) {
          return '<span class="bapw__summary-line">' + escapeHtml(line.variant.c + ' / ' + line.variant.s + ' · ' + line.warehouse.code + ' × ' + line.qty) +
            '<button type="button" data-remove="' + escapeHtml(line.key) + '" aria-label="Remove">×</button></span>';
        }).join('')
        : '<span class="bapw__summary-empty">Enter quantities above to build your order.</span>';
    }

    var piecesNode = $(self.root, '[data-bapw-pieces]');
    var subtotalNode = $(self.root, '[data-bapw-subtotal]');
    var clear = $(self.root, '[data-bapw-clear]');
    var button = $(self.root, '[data-bapw-atc]');

    if (piecesNode) piecesNode.textContent = formatNumber(pieces) + ' pcs';
    if (subtotalNode) subtotalNode.textContent = formatMoney(subtotal, self.moneyFormat);
    if (clear) clear.hidden = !lines.length;
    if (button && !button.dataset.busy) button.disabled = !lines.length;
  };

  WholesaleProduct.prototype.showMessage = function (text, type) {
    var node = $(this.root, '[data-bapw-message]');
    if (!node) return;
    node.textContent = text;
    node.className = 'bapw__message' + (type ? ' is-' + type : '');
    node.hidden = !text;
  };

  WholesaleProduct.prototype.addToCart = function () {
    var self = this;
    var lines = self.orderLines();
    var button = $(self.root, '[data-bapw-atc]');
    if (!lines.length || !button) return;

    var point = zipToPoint(self.zip);
    var items = lines.map(function (line) {
      var days = transitDays(line.warehouse, point);
      var properties = { Warehouse: line.warehouse.name, _warehouse_code: line.warehouse.code };
      if (days != null) {
        properties['Est. Delivery'] = estimateDelivery(line.warehouse, days, self.processingDays);
        properties._ship_zip = self.zip;
      }
      return { id: line.variant.id, quantity: line.qty, properties: properties };
    });

    var label = button.textContent;
    button.dataset.busy = 'true';
    button.disabled = true;
    button.textContent = 'Adding…';
    self.showMessage('', null);

    var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
          return body;
        });
      })
      .then(function () {
        self.quantities = {};
        self.renderTable();
        self.updateSwatchCounts();
        self.showMessage('Added to cart.', 'success');
        return self.refreshCart();
      })
      .catch(function (error) {
        self.showMessage(error.message || 'Could not add to cart.', 'error');
        // Shopify can partially add lines (e.g. limited by availability); keep the cart UI in sync.
        return self.refreshCart({ open: false });
      })
      .then(function () {
        delete button.dataset.busy;
        button.textContent = label;
        self.updateSummary();
      });
  };

  /* Mirrors theme.js: re-render the AJAX cart drawer, sync counters, open the drawer. */
  WholesaleProduct.prototype.refreshCart = function (options) {
    var open = !options || options.open !== false;
    var drawer = document.getElementById('AjaxCartDrawer');
    var cartCount = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (node) {
          node.textContent = String(cart.item_count);
        });
      })
      .catch(function () {});

    if (!drawer) {
      if (open) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return cartCount;
    }

    var drawerMarkup = fetch('/?section_id=ajax-cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').getElementById('AjaxCartDrawer');
        if (next) drawer.innerHTML = next.innerHTML;
        if (!open) return;
        var content = document.getElementById('CartDrawerContent');
        drawer.classList.remove('invisible', 'opacity-0');
        drawer.setAttribute('aria-hidden', 'false');
        if (content) content.classList.remove('translate-x-full');
        document.body.style.overflow = 'hidden';
      })
      .catch(function () {});

    return Promise.all([cartCount, drawerMarkup]);
  };

  /* ---------------- Events ---------------- */

  WholesaleProduct.prototype.bindStatic = function () {
    var self = this;
    var root = self.root;

    root.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-bapw-swatches] [data-color]');
      if (swatch) { self.selectColor(swatch.dataset.color); return; }

      var chip = event.target.closest('[data-bapw-warehouses] [data-warehouse]');
      if (chip) {
        self.selectedWarehouse = chip.dataset.warehouse;
        self.renderWarehouses();
        self.renderTable();
        return;
      }

      var thumb = event.target.closest('[data-bapw-thumbs] [data-src]');
      if (thumb) {
        var main = $(root, '[data-bapw-main-image]');
        if (main) main.src = thumb.dataset.src;
        $$(root, '[data-bapw-thumbs] [data-src]').forEach(function (node) {
          node.setAttribute('aria-current', node === thumb ? 'true' : 'false');
        });
        return;
      }

      var remove = event.target.closest('[data-remove]');
      if (remove) {
        delete self.quantities[remove.dataset.remove];
        self.renderTable();
        self.updateSwatchCounts();
        return;
      }

      if (event.target.closest('[data-bapw-clear]')) {
        self.quantities = {};
        self.showMessage('', null);
        self.renderTable();
        self.updateSwatchCounts();
        return;
      }

      if (event.target.closest('[data-bapw-atc]')) { self.addToCart(); return; }

      var tab = event.target.closest('[data-bapw-tab]');
      if (tab) {
        $$(root, '[data-bapw-tab]').forEach(function (node) {
          var selected = node === tab;
          node.setAttribute('aria-selected', selected ? 'true' : 'false');
          var panel = document.getElementById(node.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      }
    });

    root.addEventListener('input', function (event) {
      if (event.target.matches('.bapw__qty')) self.setQuantity(event.target);
    });

    root.addEventListener('change', function (event) {
      if (event.target.matches('.bapw__qty')) {
        var value = self.quantities[event.target.dataset.key] || '';
        event.target.value = value;
        event.target.classList.remove('is-over');
      }
      if (event.target.matches('[data-bapw-zip]')) self.applyZip(event.target.value);
    });

    root.addEventListener('keydown', function (event) {
      if (event.target.matches('[data-bapw-zip]') && event.key === 'Enter') {
        event.preventDefault();
        self.applyZip(event.target.value);
      }
    });
  };

  WholesaleProduct.prototype.applyZip = function (value) {
    var zip = String(value || '').replace(/\D/g, '').slice(0, 5);
    this.zip = zip;
    if (zipToPoint(zip)) {
      this.saveZip(zip);
      if (this.selectedWarehouse !== ALL) this.selectedWarehouse = this.nearestWarehouseCode();
    }
    this.renderWarehouses();
    this.renderTable();
  };

  function init() {
    document.querySelectorAll('[data-bapw]').forEach(function (root) {
      if (root.dataset.bapwReady) return;
      root.dataset.bapwReady = 'true';
      new WholesaleProduct(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
